import { useNavigate } from 'react-router-dom';

export default function HomeFooter() {
  const navigate = useNavigate();
  const logoSrc = 'https://static.readdy.ai/image/7e0624576d141773c913eba1868f652c/ea02af35c9a274d0014fddb0274b3cab.png';
  const appStoreUrl = 'https://apps.apple.com/sn/app/foi-s%C3%A9n%C3%A9gal/id6788168922?l=fr-FR';
  const playStoreUrl = 'https://play.google.com/store/apps/details?id=org.foisenegal.mobile&pcampaignid=web_share';
  const storeBadges = [
    { label: 'Disponible sur', store: 'App Store', icon: 'ri-apple-fill', href: appStoreUrl },
    { label: 'Télécharger sur', store: 'Google Play', icon: 'ri-google-play-fill', href: playStoreUrl },
  ];

  return (
    <footer className="border-t border-gold/20 bg-[#F0EDE6]">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="mb-4 flex items-center gap-3">
              <img src={logoSrc} alt="Foi Senegal" className="h-10 w-10 rounded-xl bg-white object-contain" />
              <span className="text-xl font-bold text-navy">Foi Senegal</span>
            </div>
            <p className="mb-6 max-w-xs text-sm leading-relaxed text-gray-500">
              L'application mobile chretienne nationale qui centralise les eglises du Senegal et facilite les liens entre fideles, eglises, organisateurs et vendeurs d'articles religieux.
            </p>
            <div className="mb-6 flex flex-wrap gap-3">
              {storeBadges.map((badge) => (
                <a
                  key={badge.store}
                  href={badge.href}
                  target={badge.href ? '_blank' : undefined}
                  rel={badge.href ? 'noreferrer' : undefined}
                  aria-disabled={!badge.href}
                  onClick={(event) => {
                    if (!badge.href) event.preventDefault();
                  }}
                  className={`flex items-center gap-2 rounded-xl bg-navy px-3 py-2 text-left text-white shadow-sm ${badge.href ? 'cursor-pointer transition hover:bg-navy-light' : 'cursor-default'}`}
                  aria-label={`${badge.label} ${badge.store}`}
                >
                  <i className={`${badge.icon} text-2xl`}></i>
                  <span className="leading-tight">
                    <span className="block text-[10px] uppercase tracking-wide text-white/70">{badge.label}</span>
                    <span className="block text-sm font-bold">{badge.store}</span>
                  </span>
                </a>
              ))}
            </div>
            <div className="flex gap-3">
              {[
                { icon: 'ri-facebook-circle-fill', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-twitter-x-line', href: '#' },
                { icon: 'ri-linkedin-box-line', href: '#' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg bg-navy/10 text-navy transition-all hover:bg-navy hover:text-white"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-navy">Plateforme</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Devenir vendeur', action: () => navigate('/register?role=vendor') },
                { label: 'Devenir organisateur', action: () => navigate('/register?role=organizer') },
                { label: 'Se connecter', action: () => navigate('/login') },
                { label: 'Comment ça marche', action: () => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' }) },
              ].map((item) => (
                <li key={item.label}>
                  <button onClick={item.action} className="cursor-pointer whitespace-nowrap text-sm text-gray-500 transition-colors hover:text-navy">
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold uppercase tracking-wider text-navy">Contact</h4>
            <ul className="space-y-3">
              {[
                { icon: 'ri-map-pin-line', text: 'Dakar, Senegal' },
                { icon: 'ri-mail-line', text: 'foisenegal@gmail.com' },
                { icon: 'ri-phone-line', text: '78 793 36 36' },
                { icon: 'ri-time-line', text: 'Lun-Ven, 8h-18h' },
              ].map((contact) => (
                <li key={contact.text} className="flex items-center gap-2.5 text-sm text-gray-500">
                  <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-navy/10">
                    <i className={`${contact.icon} text-xs text-navy`}></i>
                  </div>
                  {contact.text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-navy/10 pt-8 sm:flex-row">
          <p className="text-sm text-gray-400">© 2026 Foi Senegal · Tous droits réservés</p>
          <div className="flex gap-6">
            {[
              { label: 'Politique de confidentialité', path: '/privacy' },
              { label: "Conditions d'utilisation", path: '/terms' },
              { label: 'Mentions légales', path: '/terms' },
            ].map((item) => (
              <button
                key={item.label}
                onClick={() => navigate(item.path)}
                className="cursor-pointer whitespace-nowrap text-xs text-gray-400 transition-colors hover:text-navy"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
